import React from 'react';
import { ObjectizerModel } from '@leverege/condition';
import { ModelEditorFactory, SharedContext } from '@leverege/ui-plugin';
import ConditionFilterOptionsCreators from "../../filters/filter/ConditionFilterOptionsCreators.js";
import ColorEditor from "./ColorEditor.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ConditionColorizerEditor(props) {
  const {
    objectType,
    delegate,
    relationship
  } = props;
  const Editor = ModelEditorFactory.get(ObjectizerModel.TYPE);
  const optionsCreator = ConditionFilterOptionsCreators.getOptionsCreatorFor(delegate.type, objectType);
  const {
    creators,
    conditionOptions
  } = optionsCreator?.create?.(props) || {};
  return /*#__PURE__*/_jsx(SharedContext, {
    conditionCreators: creators,
    conditionOptions: conditionOptions,
    objectType: objectType,
    delegate: delegate,
    relationship: relationship,
    children: /*#__PURE__*/_jsx(Editor, {
      ...props,
      valueEditor: ColorEditor
    })
  });
}